<div class="badge-container" *ngIf="currentBadgeType != null">
	<span class="badge-msg" [ngClass]="currentBadgeType">{{ getMessageTranslationKey() | translate }}</span>
	<div
		class="action-container" *ngIf="shouldShowAction()">
		<button
			(click)="actionClick.emit()"
			[disabled]="loading || disabled"
			class="secondary-btn btn-sm badge-btn"
			[attr.aria-label]="getAriaLabelTranslationKey() | translate">
			{{ getActionTranslationKey() | translate }}
		</button>
		<i *ngIf="loading" class="ficon-spinner ficon-spin" aria-live="polite" [attr.aria-label]="'common_loading'| translate"></i>
	</div>
</div>
